import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { useI18NextStore } from './use-store';

export type I18NextProviderProps = {
	children?: React.ReactNode;
};

export const MAEDefaultI18NextProvider = ({ children }: I18NextProviderProps): JSX.Element => {
	const [i18NextStore] = useI18NextStore();

	return <I18nextProvider i18n={i18NextStore.store.I18n}>{children}</I18nextProvider>;
};
